import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Italic = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <path d="M12.3033 9.57143H13.9426L12.1393 16H10.5L12.3033 9.57143ZM13.6803 7C13.5182 7 13.3597 7.0377 13.2249 7.10834C13.0901 7.17898 12.9851 7.27938 12.923 7.39685C12.861 7.51431 12.8448 7.64357 12.8764 7.76827C12.908 7.89297 12.9861 8.00752 13.1007 8.09743C13.2154 8.18733 13.3614 8.24856 13.5204 8.27336C13.6794 8.29817 13.8442 8.28544 13.994 8.23678C14.1438 8.18812 14.2718 8.10573 14.3619 8.00001C14.4519 7.89429 14.5 7.77 14.5 7.64286C14.5 7.47236 14.4136 7.30885 14.2599 7.18829C14.1062 7.06773 13.8977 7 13.6803 7Z" />
  </SvgIcon>
));

export default React.memo(Italic);
